import React, { useEffect } from "react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { MEDIA_URL } from "../../config/url";
import { encryptData } from "../../utils/storage";
import { Link } from "react-router-dom";

export const Blogs = ({ blogstable }) => {
  return (
    <>
      <section className="layout-pt-sm layout-pb-sm bg-light-4">
        <div className="container">
          {/* <div
            data-anim-child="slide-up delay-1"
            className="row y-gap-20 justify-between items-end"
          >
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title text-primary">
                  Read our latest blog
                </h2>
              </div>
            </div>
          </div> */}

          {/* <Swiper
            // className="main-swiper"
            // overflow-hidden
            className="pt-40 pb-40 blogSwiper"
            // pb-5 px-5
            spaceBetween={20}
            // slidesPerView={1}
            breakpoints={{
              768: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              769: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            loop={true}
            loopFillGroupWithBlank={true}
            modules={[Autoplay, Pagination, Navigation]}
          > */}
          <Swiper
            className="pt-40 pb-40 blogSwiper"
            spaceBetween={50}
            breakpoints={{
              768: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              769: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            loop={true}
            loopFillGroupWithBlank={true}
            modules={[Pagination, Navigation, Autoplay]}
          >
            <div className="row y-gap-20 swiper-header">
              <div className="sectionTitle -md lg:pt-15">
                <h2 className="sectionTitle__title text-primary lg:text-20">
                  Read Our Latest Blogs
                </h2>
              </div>
            </div>
            {blogstable?.map((rowdatablog, index) => {
              const encryptedParam = encryptData(rowdatablog?.Blog_Id);

              return (
                <SwiperSlide className="swiper-child" key={index}>
                  <Link
                    to={`/blog/${encryptedParam}`}
                    className="blogCard -type-4 d-block bg-white px-20 py-20 rounded-16"
                  >
                    <div className="blogCard__image rounded-16 ratio ratio-2:1">
                      <img
                        className="img-ratio rounded-16 js-lazy"
                        src={`${MEDIA_URL}${rowdatablog?.Image_Path}`}
                        alt="blog"
                      />
                      <div class="cardImage__leftBadge">
                        <div class="py-5 px-15 rounded-right-4 text-13 lh-16 fw-600 uppercase bg-primary text-white">
                          {rowdatablog?.BlogType}
                        </div>
                      </div>
                    </div>
                    <div className="blogCard__content mt-10 relative">
                      <h4 className="text-15 lh-13 fw-600 text-dark-1 trim-2">
                        {rowdatablog?.Short_Description}
                      </h4>
                      <div className="text-12 text-light-1 lh-15 mt-10 trim-3 fw-500 font-inter text-justify">
                        {rowdatablog?.Long_Description}
                      </div>
                      <div className="text-12 text-light-1 lh-14 mt-15 trim-3 fw-500 font-inter">
                        <i className="far fa-calendar text-primary text-14 mr-10 fw-600"></i>
                        {rowdatablog?.Created_On}
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              );
            })}
          </Swiper>

          {/* <div
            className="pt-40 pb-5 px-5 overflow-hidden js-section-slider"
            data-gap="30"
            data-slider-cols="xl-3 lg-3 md-3 sm-2 base-1"
            data-nav-prev="js-places-prev"
            data-pagination="js-places-pag"
            data-nav-next="js-places-next"
          >
            <div className="swiper-wrapper">
              {blogstable?.map((rowdatablog) => {
                return (
                  <div
                    // data-anim-child="slide-left delay-4"
                    className="swiper-slide"
                    key={rowdatablog.Blog_Id}
                  >
                    <a
                      href="#"
                      className="blogCard -type-4 d-block bg-white px-20 py-20 rounded-16"
                    >
                      <div className="blogCard__image rounded-16 ratio ratio-3:2">
                        <img
                          className="img-ratio rounded-16 js-lazy"
                          data-src="img/blog/blog1.png"
                          src="#"
                          alt="blog"
                        />
                        <div class="cardImage__leftBadge">
                          <div class="py-5 px-15 rounded-right-4 text-13 lh-16 fw-600 uppercase bg-primary text-white">
                            Running
                          </div>
                        </div>
                      </div>
                      <div className="blogCard__content mt-10 relative">
                        <h4 className="text-15 lh-13 fw-600 text-dark-1 trim-2">
                          {rowdatablog.Short_Description}
                        </h4>
                        <div className="text-13 text-light-1 lh-14 mt-10 trim-3">
                          {rowdatablog.Long_Description}
                        </div>
                        <div className="text-13 text-light-1 lh-14 mt-10 trim-3 fw-600">
                          <i className="far fa-calendar text-primary text-16 mr-10 fw-600"></i>
                          {rowdatablog.Created_On}
                        </div>
                      </div>
                    </a>
                  </div>
                );
              })}
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
};

// {
/* <div data-anim-child="slide-left delay-4" className="swiper-slide" >
              <a href="#" className="blogCard -type-4 d-block bg-white px-20 py-20 rounded-16">
                <div className="blogCard__image rounded-16 ratio ratio-3:2">
                  <img className="img-ratio rounded-16 js-lazy" data-src="img/blog/blog1.png" src="#" alt="image" />
                </div>
                <div className="blogCard__content mt-10 relative">
                  <h4 className="text-15 lh-13 fw-600 text-dark-1 trim-2">jjk</h4>
                  <div className="text-13 text-light-1 lh-14 mt-10 trim-3">klfoijweriojer</div>
                  <div className="text-14 text-light-1 lh-14 mt-10 trim-3 fw-600"><i className="far fa-calendar text-primary text-16 mr-10 fw-600"></i>dsklfwr02934329048290</div>
                </div>
              </a>
            </div> */
// }
